import { useState, useEffect } from 'react';
import { get } from 'lodash';

export const useAuditNewDesignFlag = (firebase, storeId) => {
    const [isNewDesignEnabled, setIsNewDesignEnabled] = useState(false);

    useEffect(() => {
        if (!firebase || !storeId) return;

        const unsubscribe = firebase
            .collection('salesChannel')
            .doc(storeId)
            .onSnapshot((doc) => {
                setIsNewDesignEnabled(get(doc.data(), 'auditMonitorNewDesign', false));
            });

        return () => unsubscribe();
    }, [firebase, storeId]);

    return isNewDesignEnabled;
};